import { useEffect, useState } from 'react'
import { cloneDeep } from 'lodash'
import { useAppSelector } from 'redux/hooks'
import { PinnedCardsRecordType } from 'services/apiTypes/pinnedCards.types'
import { SortOptionType } from 'types/deck'

import { SortFunctionMap } from 'redux/deck/helpers/sorting'

const usePinnedDisplayCards = (
  pinnedCards: Record<string, PinnedCardsRecordType>,
  orderBy: SortOptionType,
  sortDirectionDescending: boolean,
  filteredCards: string[],
) => {
  const [displayCards, setDisplayCards] = useState<PinnedCardsRecordType[]>([])
  const priceSource = useAppSelector(state => state.active.priceSource)

  useEffect(() => {
    const sortFunction = SortFunctionMap[orderBy]

    let cards = cloneDeep(Object.values(pinnedCards))

    if (filteredCards.length !== 0) {
      cards = cards.reduce((acc, cardRecord) => {
        if (filteredCards.includes(cardRecord.card.name)) acc.push(cardRecord)
        return acc
      }, new Array<PinnedCardsRecordType>())
    }

    cards.sort((a, b) => sortFunction(a.card, b.card, priceSource))
    if (sortDirectionDescending) cards.reverse()

    setDisplayCards(cards)
  }, [pinnedCards, orderBy, sortDirectionDescending, filteredCards])

  return displayCards
}

export default usePinnedDisplayCards
